import { render } from "./CategorySort.vue?vue&type=template&id=5254b91e&scoped=true"
import script from "./CategorySort.vue?vue&type=script&lang=js"
export * from "./CategorySort.vue?vue&type=script&lang=js"

import "./CategorySort.vue?vue&type=style&index=0&id=5254b91e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5254b91e"

export default script